import { TextField, TextFieldProps } from '@/global/components/TextField'
import { useLocationTestId } from '@/hooks/useTestId'
import { cn } from '@/lib/utils'
import localeText from '@/locales/datagrid'
import { SearchIcon } from 'lucide-react'
import { GridFilterModelPro } from '../utils/filterModelPro'
import { useTableApiContext } from '../utils/table-context'

type Props = TextFieldProps & {
    disabled?: boolean
}

/**
 * Precisa estar no contexto do TableApiProvider
 */
export default function QuickFilter({ disabled, ...rest }: Props) {
    const {
        filterModelPro: { quickFilterValue = '' },
        onFilterModelChangePro,
    } = useTableApiContext()
    const quickFilterTestId = useLocationTestId('pesquisa-rapida')

    return (
        <NoContextQuickFilter
            disabled={disabled}
            quickFilterValue={quickFilterValue}
            onFilterModelChangePro={onFilterModelChangePro}
            {...rest}
            data-testid={quickFilterTestId}
        />
    )
}

interface ContextValues {
    quickFilterValue: string
    onFilterModelChangePro: (
        updater: React.SetStateAction<GridFilterModelPro>,
    ) => void
}

export function NoContextQuickFilter({
    disabled,
    quickFilterValue,
    onFilterModelChangePro,
    ...rest
}: Props & ContextValues) {
    return (
        <TextField
            {...rest}
            className={cn(rest.className, disabled && 'opacity-disabled')}
            startAdornment={<SearchIcon className="opacity-75 mb-1" />}
            variant="outlined"
            unHelperText
            autoComplete="off"
            placeholder={localeText.toolbarQuickFilterPlaceholder}
            disabled={disabled}
            defaultValue={quickFilterValue}
            onChange={(
                event: React.ChangeEvent<
                    HTMLInputElement | HTMLTextAreaElement
                >,
            ) => {
                onFilterModelChangePro(prev => ({
                    ...prev,
                    quickFilterValue: event.target.value || '',
                }))
            }}
        />
    )
}
